module.exports = __webpack_public_path__ + "img/shangjia.1e453d69.png";